import * as types from './types';

export const resetAddress = ({ commit }) => {
  commit(types.RESET_ADDRESS);
};

export const setSuggestions = ({ commit }, payload) => {
  commit(types.SET_SUGGESTIONS, payload);
};

export const setVisibility = ({ commit }, payload) => {
  commit(types.SET_VISIBILITY, payload);
};

export const setAddressValidity = ({ commit }, payload) => {
  commit(types.SET_ADDRESS_VALIDITY, payload);
};

export const setAddress = ({ commit }, payload) => {
  if (payload.Technology) {
    let coverage;

    switch (payload.Technology) {
      case 'CoverageDST':
        coverage = 'dst';
        break;
      case 'CoverageSTV':
        coverage = 'stv';
        break;
      case 'CoverageFTTHNowo':
        coverage = 'ftth';
        break;
      default:
        coverage = 'nowo';
    }

    commit(types.SET_COVERAGE_TYPE, coverage);
  }

  commit(types.SET_ADDRESS, payload);
};

export const setNotCoveredAddress = ({ commit }, payload) => {
  commit(types.SET_NOT_COVERED_ADDRESS, payload);
};

export const setTimesInCoverage = ({ commit }, payload) => {
  commit(types.SET_TIME_IN_COVERAGE, payload);
};

export const setCoverageType = ({ commit }, payload) => {
  commit(types.SET_COVERAGE_TYPE, payload);
};

export default {
  resetAddress,
  setAddress,
  setAddressValidity,
  setSuggestions,
  setVisibility,
  setNotCoveredAddress,
  setTimesInCoverage,
  setCoverageType
};



// WEBPACK FOOTER //
// ./src/store/modules/addresses/actions.js